import {getApiMetadata} from '../../helpers/api-metadata'
import {ContentType} from '../../platform/content-type'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {UpdateSidePanelItemReactionRequest} from './contracts'

export async function apiUpdateSidePanelItemReaction(body: UpdateSidePanelItemReactionRequest): Promise<void> {
  const apiData = getApiMetadata('memex-update-sidepanel-item-reaction-api-data')
  const {data} = await fetchJSON<UpdateSidePanelItemReactionRequest, void>(apiData.url, {
    method: 'POST',
    body,
    token: apiData.token,
    contentType: ContentType.FormData,
  })
  return data
}
